import { GADataLayerItem } from '../../../src/components/Questions/utils'

export default {
  push: (item: GADataLayerItem) => {
    window.dataLayer.push(item)
  }
}
